import { useWorkoutCardContext } from './workout-card'
import { WorkoutCardOverlay } from './workout-card-overlay'
import React, { ReactNode } from 'react'
import { ImagePublicFileId } from 'src/component/image/image-public-file-id'
import { cn } from 'src/lib/utils'

interface WorkoutCardImageProps {
  children?: ReactNode
  className?: string
}

export const WorkoutCardImage = ({ children, className }: WorkoutCardImageProps): React.ReactElement => {
  const { workout } = useWorkoutCardContext()

  return (
    <div className="relative w-full h-full">
      <ImagePublicFileId fileId={workout.imagePublicFileId} className={cn('w-full h-full object-cover rounded-md', className)} />
      {children && <WorkoutCardOverlay>{children}</WorkoutCardOverlay>}
    </div>
  )
}
